import { ratesByState } from '@/app/(marketplace)/quote-builder/electricity-rates/rates';

import { historicalRatesByState } from '../data/historicalRates';
import { NATIONAL_ESCALATOR, ProjectionScenario, stateEscalator } from '../data/rateProjections';

const RECENT_WINDOW_START = 2015;

// The state's actual last-decade pace (2015 → latest EIA year) — the "hot"
// scenario. Falls back to the national AEO rate if either series is missing.
export const recentDecadeCagr = (stateCode: string): number => {
  const startRate = historicalRatesByState[stateCode]?.find(({ year }) => year === RECENT_WINDOW_START)?.rate;
  const rates = ratesByState[stateCode]?.rates;
  const latest = rates?.[rates.length - 1];
  if (!startRate || !latest) {
    return NATIONAL_ESCALATOR;
  }
  return (latest.rate / startRate) ** (1 / (latest.year - RECENT_WINDOW_START)) - 1;
};

// Long-run escalator for each reader-selectable scenario. BLEND averages the
// two named views rather than claiming a prediction of its own.
export const scenarioEscalator = (stateCode: string, scenario: ProjectionScenario): number => {
  if (scenario === 'AEO') {
    return stateEscalator(stateCode);
  }
  if (scenario === 'RECENT') {
    return recentDecadeCagr(stateCode);
  }
  return (stateEscalator(stateCode) + recentDecadeCagr(stateCode)) / 2;
};
